export default {
  absence: {
    absence: "Absence",
    absence_not_justified: "Unjustified absence",
    absence_waiting_for_validation: "Pending validation",
    absences_not_justified: "Unjustified absences",
    absences: "Absences",
    course: "Lessons",
    company: "InseeCompany",
    add_notification: "Send notification of a new certificate",
    add_event: "Add an event",
    edit_event: "Edit an event",
    delete_event: "Delete an event",
    delete_events: "Delete events",
    delete_event_sub_title: "Are you sure you want to delete this event?",
    delete_events_sub_title: "Are you sure you want to delete these events?",
    delete_event_success: "Event deleted successfully!",
    copy_event_success: "Event copied successfully!",
    cut_event_success: "Event cut successfully!",
    delete_events_success: "Events deleted successfully!",
    post_event: "Event added successfully!",
    list_planning: "List of events",
    list_planning_search: "Search for events",
    import_planning: "Import schedule",
    import_planning_success: "Schedule imported successfully!",
    export_planning: "Export schedule",
    export_planning_success: "Schedule exported successfully!",
    add_absence: "Add absence(s)",
    edit_absence: "Edit an absence",
    delete_absence: "Delete an absence",
    delete_absences: "Delete absences",
    delete_absence_sub_title: "Are you sure you want to delete this absence?",
    delete_absences_sub_title: "Are you sure you want to delete these absences?",
    delete_absence_success: "Absence deleted successfully!",
    copy_absence_success: "Absence copied successfully!",
    cut_absence_success: "Absence cut successfully!",
    delete_absences_success: "Absences deleted successfully!",
    post_absence: "Absence added successfully!",
    list_absences: "List of absences",
    list_absences_search: "Search for absences",
    list_attendance_certificate: "List attendance certificates",
    attendance_certificate_export_confirmed: "Attendance certificate exported successfully!",
    list_of_attendance_certificate: "List of attendance certificates",
    no_attendance_certificate_available: "There is no attendance certificate yet",
    no_attendance_certificate_available_for_month: "There is no attendance certificate for the month of",
    download_certificate: "Download the certificate",
    import_absences: "Import absences",
    import_absences_success: "Absences imported successfully!",
    notification: "Certification notification",
    absence_ask: "Application for exceptional leave of absence",
    display_apprentice_list: "Display list of",
    hide_apprentice_list: "Hide list of apprentices",
    training_detail: "View training details",
    apprentice_list: "List of",
    personnal_data: "Personal data",
    sheet_from: "Record of",
    event_moved_success: "Event moved successfully!",
    absence_moved_success: "Absence moved successfully!",
    justify: "Give reasons",
    justify_many_absence: "Justify several of my absences",
    submit_proof: "Submit proof of absence",
    proof_downloaded: "File successfully downloaded",
    planning: "Event",
    not_justify: "Not approved",
    justified: "Approved",
    in_progress: "Pending validation",
    start_date: "Start date",
    end_date: "End date",
    start_time: "Start time",
    end_time: "End time",
    duration: "Duración",
    type: "Type",
    verify_date: "Please enter the dates corresponding to the supporting document submitted.",
    linked_to_planning: "This absence is linked to an event",
    already_exit: "An absence is already recorded for this period",
    context_menu: {
      copy: "Copy",
      cut: "Cut",
      paste: "Paste",
      delete: "Delete",
      modify: "Edit this event",
      add: "Add an event",
      modify_absence: "Edit this absence",
      add_absence: "Add an absence",
    },
    actions: {
      planning: "Schedule management",
      absences: "Attendance management",
      options: "Options",
    },
    justification: {
      valid: {
        confirmation: "Are you sure you want to validate this absence?",
        success: "Absence validated successfully",
      },
      action: {
        unvalid: "Invalidate",
      },
      unvalid: "Invalid receipt",
      status: {
        waiting_for_validation: "Awaiting validation",
        to_verify: "To be checked",
        justify: "Justify my absence",
        justified: "Justified",
        download: "Download proof of absence",
        waiting_proof: "Awaiting supporting documents",
        invalid: "Invalid justification",
      },
      notify_apprentice: "Notify the work-study student in the event of refusal",
    },
    verification: "Checking absence",
    signature: {
      valid: "Confirm",
      unlock: "Unlock",
      invalid: "Invalidate",
      title: "Signature",
      former: "Teacher",
      lesson: "Lesson",
      establishment: "Establishment",
      component: "Component",
      address: "Address",
      confirmation: "Are you sure you want to confirm this signature?",
      already_validate: "Enrolment validated",
      reset: {
        title: "Reset absences and presences",
      },
      unlock_signature: {
        confirmation: "Are you sure you want to unlock this signature?",
        success: "Signature successfully unlocked!",
      },
      valid_all_signature: "Validate all selected signatures",
      valid_all: {
        title: "Signature validation",
        confirmation: "Are you sure you want to approve all these signatures?",
        success: "Signatures successfully validated!",
      },
      reset_absence: {
        confirmation: "¿Está seguro de que desea restablecer todas las ausencias de este evento?",
        subtitle: "All apprentices will be moved to the 'To be defined' column",
        success: "¡Ausencias restablecidas con éxito!",
      },
      signed_at: "Signed on:",
    },
    status: {
      title: "Status",
      absents: "Absents",
      to_be_defined: "To be defined",
      attendees: "Attendees",
      cancel: "Session cancelled",
      all_present: "All present at the session",
      to_valid: "Registration to be validated",
      no_absence_or_presence: " (no absence or attendance)",
      with_absence: "Session validated with absences",
    },
    attendance_management: {
      title: "Attendance management",
      external_title: "Attendance management with signature sheet",
      transfer_to: {
        absence: "Transfer all apprentices to the absent column",
        attendance: "Transfer all apprentices to the attendee columns",
      },
    },
    presence: {
      title: ({ plural }) => plural(["Presence", "Presences"]),
    },
    reason: "Reason for absence",
    config: {
      valid: {
        confirmation: "Are you sure you want to confirm this configuration?\n",
        success: "Configuration successfully validated!",
      },
    },
    empty_unjustify: "No unjustified absence",
  },
};
